import React, { FC, ReactElement } from 'react';
import { TableCell, Typography, makeStyles } from '@material-ui/core';
import moment from 'moment-timezone';

interface IProps {
  deliveryInterval: ReactElement;
  sendAt: number;
}

const useStyles = makeStyles(theme => ({
  deliveryInterval: { marginTop: theme.spacing() },
}));

const DateCell: FC<IProps> = ({ deliveryInterval, sendAt }) => {
  const classes = useStyles();

  const sendAtMoment = moment.unix(sendAt);
  const tzName = sendAtMoment.tz(moment.tz.guess()).format('z');

  return (
    <TableCell>
      <Typography variant="body2" className={classes.deliveryInterval}>
        {deliveryInterval}
      </Typography>
      <Typography variant="body2" className={classes.deliveryInterval}>
        {sendAtMoment.format('ddd, MMM DD')}
      </Typography>
      <Typography>
        {sendAtMoment.format('hh:mm A')} ({tzName})
      </Typography>
    </TableCell>
  );
};

export default DateCell;
